import moment from "moment"
export default function times() {
	let ret = {
		//lastYear: moment.unix(moment().startOf("year").unix()).subtract(365, "days").unix(),
		lastYear: moment().subtract(1, 'year').startOf('year').unix(),
		thisYear: moment().startOf("year").unix(),
		thisWeek: moment().startOf("isoweek").unix(),
		endThisWeek: moment().endOf("isoweek").unix(),
		endWeek: moment().startOf("isoweek").unix(),
		lastWeek: moment().startOf("isoweek").subtract(1, "week").unix(),
		lastWeekEnd: moment().startOf("isoweek").subtract(1, "week").endOf("isoweek").unix(),
		startWeek: moment().startOf("isoweek").subtract(7, "days").unix(),
		priorEndWeek: moment().startOf("isoweek").subtract(1, "year").unix(),
		priorStartWeek: moment().startOf("isoweek").subtract(1, "year").subtract(7, "days").unix(),
		currentPoint: moment().subtract(1, "year").unix(),
		year: new Date().getFullYear(),
		dayOfMonth: moment().date(),
		curMonth: moment().month() + 1,
		curWeek: moment().isoWeek(),
		curWeekNumber: moment().week(),
		lastWeekNumber: moment().subtract(7, "days").isoWeek(),
		lastPoint: moment().subtract(1, 'year').unix()
	}
	return ret
}